module.exports = __webpack_public_path__ + "static/media/ai-icon.d2d429ea.svg";